import { Link } from "react-router-dom";
import { categories, videos } from "@/mocks/videos";

function countOf(categoryId: string): number {
  return videos.filter((video) => video.categoryId === categoryId).length;
}

export default function CategoryGrid() {
  return (
    <div className="-mx-4 flex gap-3 overflow-x-auto px-4 pb-2 lg:mx-0 lg:grid lg:grid-cols-6 lg:gap-4 lg:overflow-visible lg:px-0 lg:pb-0">
      {categories.map((category) => (
        <Link
          key={category.id}
          to={`/category/${category.id}`}
          className="group flex min-w-[132px] flex-col items-center rounded-lg border border-background-200 bg-background-50 px-3 py-5 text-center transition-all hover:border-primary-300 hover:bg-primary-50 lg:min-w-0"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${category.icon} text-2xl`}></i>
          </span>
          <span className="mt-3 font-heading text-sm font-semibold text-foreground-950">
            {category.name}
          </span>
          <span className="mt-1 text-xs text-foreground-500">{countOf(category.id)} 个视频</span>
        </Link>
      ))}
    </div>
  );
}